import { z } from "zod";

export type ChatMessageType = "first" | "date" | "result" | "reasoning" | "success" | "navigation" | "create-post" | "calendar" | "campaign" | "story"

export type ThemeEvent = {
  event_id: number;
  stories: boolean | null
  event_name: string;
  start_date: string; // ISO date string (e.g., "2025-07-01")
  end_date: string;   // ISO date string
  reasoning: string;
  image_url: string;
  viewed: boolean;
};

export type SocialPostType = {
  post_id: number;
  post_content: string;
  post_date: string; // ISO date string (e.g., "2025-07-01")
  post_time: string; // Time string in HH:mm:ss format
  tags: string[];
  image_video_recommendation: string;
  platform: string;
  type: string;
  image_url: string;
  image_id: number;
  catalogue: string;
  image_ids: { image_id: number, image_url: string, type: string }[] | null
}

export const PostBodyFormSchema = z.object({
  post_content: z.string().min(1, "Content is required"),
  post_id: z.number(),
  hashtags: z.array(z.string().min(1)),
  post_date: z.date(),
  post_time: z.string(),
  image_recommendation: z.string(),
  catalogue: z.string()
})

export type PostBodyFormType = z.infer<typeof PostBodyFormSchema>;


export const CreatePostFormSchema = z.object({
  event_time: z.string().optional(),
  event_description: z.string().min(1, { message: "Please provide a brief" }),
  activity: z.enum(["Campaign", "Post"]),
  campiagn_timeline: z.coerce.date().optional(),
  event_date: z.coerce.date(),
})

export type CreatePostFormType = z.infer<typeof CreatePostFormSchema>;

export type GeneratedSingleThemeType = {
  post_id: number,
  post_type: string,
  text: string,
  date_of_posting: string,
  time_of_posting: string,
  platform: string,
  hashtags: string[],
  image_video_recommendation: string,
  status: string,
  image_url: string,
  catalogue: string,
  type: string
}

export type GeneratedTheme = {
  event_id: number,
  event_name: string;
  activity: "Campaign" | "Post",
  event_description: string,
  event_type: string,
  start_date: string,
  end_date: string,
  posts: GeneratedSingleThemeType[]
}


export type CalendarEvent = {
  startDate: string;
  endDate: string;
  type: "Campaign" | "Post";
  title: string;
  description: string;
  status: string;
  tags: string[];
  approved_status: number;
}

export type Platform = {
  id: number;
  name: string;
  url: string;
};

export type CampaignStory = {
  story_id: number,
  story_name: string,
  story_date: string,
  story_description: string,
  sequence_order: number,
  status: "Pending" | "Approved"
}
